import { Box, RadioGroup } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@carto/meridian-ds/components'

import useGetAccountData from 'features/account/ui/common/useGetAccountData'
import EntireOrganizationOption from 'features/common/ui/sharing/SharedWithOrganizationMode/EntireOrganizationOption'
import WithGroupsOption from 'features/common/ui/sharing/SharedWithOrganizationMode/WithGroupOption'
import { ShareWithGroups } from 'features/common/ui/sharing/ShareOptionShared/ui/ShareWithGroups'
import ConnectionShareViewerCredentials from 'features/connections/ui/ConnectionShareDialog/ConnectionShareViewerCredentials'

import ShareWithViewerCredentials from './ShareWithViewerCredentials'

function ConnectionSharedWithOrganizationMode({
  mode = 'organization',
  disabledEntireOrganization,
  tooltipEntireOrganization,
  disabledGroups,
  tooltipGroups,
  disabledViewerCredentials,
  tooltipViewerCredentials,
  groups,
  onChangeMode,
  onChangeGroups
}) {
  const accountData = useGetAccountData()
  const hasEnterpriseSso = accountData.quotas?.enterpriseSsoAvailable
  const isShareWithGroupsEnabled = hasEnterpriseSso && !disabledGroups

  return (
    <Box mt={2}>
      <Typography variant="caption" fontWeight="medium">
        <FormattedMessage id={'common.shareDialog.sharingMode.title'} />
      </Typography>
      <RadioGroup aria-label="mode" name="mode" value={mode} onChange={(_, mode) => onChangeMode(mode)}>
        <Box display="flex">
          <EntireOrganizationOption disabled={disabledEntireOrganization} tooltip={tooltipEntireOrganization} />
          <WithGroupsOption disabled={!isShareWithGroupsEnabled} tooltip={tooltipGroups} />
          <ConnectionShareViewerCredentials disabled={disabledViewerCredentials} tooltip={tooltipViewerCredentials} />
        </Box>
      </RadioGroup>
      {mode === 'groups' && (
        <ShareWithGroups
          selectedGroups={groups}
          isShareWithGroupsEnabled={isShareWithGroupsEnabled}
          onSelectedGroupsChange={onChangeGroups}
        />
      )}
      {mode === 'viewer' && <ShareWithViewerCredentials />}
    </Box>
  )
}

export default ConnectionSharedWithOrganizationMode
